import type { WakeupDisplayStatus } from '../types/wakeup'

export enum WakeupCallStatus {
  UNTRIED = 0,
  TRIED = 1,
  CANCELED = 2,
}

export enum WakeupCallDone {
  NOT_DONE = 0,
  DONE = 1,
}

export enum WakeupCallOrigin {
  PHONE = 1,
  PORTAL = 2,
}

export interface WakeupDisplayConfig {
  label: string
  colorPalette: string
}

export const WAKEUP_DISPLAY_CONFIG: Record<
  WakeupDisplayStatus,
  WakeupDisplayConfig
> = {
  scheduled: { label: 'Scheduled', colorPalette: 'blue' },
  tried: { label: 'Tried', colorPalette: 'orange' },
  cleared: { label: 'Cleared', colorPalette: 'blue' },
  canceled: { label: 'Canceled', colorPalette: 'gray' },
}

export const WAKEUP_ORIGIN_LABELS: Record<number, string> = {
  [WakeupCallOrigin.PHONE]: 'Phone',
  [WakeupCallOrigin.PORTAL]: 'Portal',
}
